<template>
    <div v-if="!loadingPage" class="pb-2">
        <h3 class="mb-2 text-primary mt-50">گزارش جامع سفارشات</h3>
        <b-row>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="تاریخ شروع" label-for="fromId">
                    <b-form-input id="fromId" class="text-center main-input font-weight-bolder pointer"
                        :value="parameters.from ? formatDate(parameters.from) : null" autocomplete="off"
                        name="fromId" />
                    <date-picker v-model="parameters.from" :max="currentDate" format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jDD" custom-input="#fromId" />
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="تاریخ پایان" label-for="toId">
                    <b-form-input id="toId" class="text-center main-input font-weight-bolder pointer" name="toId"
                        :value="parameters.to ? formatDate(parameters.to) : null" autocomplete="off" />
                    <date-picker v-model="parameters.to" :max="currentDate" format="YYYY-MM-DD"
                        display-format="jYYYY-jMM-jDD" custom-input="#toId" />
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="شماره فاکتور" label-for="storeOrderNumberId">
                    <b-form-input v-model="parameters.storeOrderNumber" @keyup.enter="ordersReport"
                        id="storeOrderNumberId" dir="ltr" type="number" autocomplete="off" class="text-center"
                        name="storeOrderNumberId" />
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="شماره همراه مشتری" label-for="customerPhoneNumberId">
                    <b-form-input v-model="parameters.customerPhoneNumber" @keyup.enter="ordersReport"
                        id="customerPhoneNumberId" dir="ltr" autocomplete="off" class="text-center"
                        name="customerPhoneNumberId" />
                </b-form-group>
            </b-col>
            <b-col md="6" lg="4" class="mt-25">
                <b-form-group label="کاربر مجموعه" label-for="userIdId">
                    <v-select v-model="parameters.userId" dir="rtl" :options="usersList" id="userIdId" class="bg-white"
                        autocomplete="off" :reduce="(value) => value.id" style="border-radius: 6px;"
                        :get-option-label="(option) => option.firstName + ' ' + option.lastName" :clearable="false">
                        <template #option="{ firstName, lastName }">
                            {{ firstName }} {{ lastName }}
                        </template>
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="مالیات" label-for="hasTaxId">
                    <v-select v-model="parameters.hasTax" :searchable="false" dir="rtl" :options="hasTaxData"
                        class="bg-white" id="hasTaxId" autocomplete="off" :reduce="(value) => value.id"
                        style="border-radius: 6px;" label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="وضعیت مرجوعی" label-for="isReturnedId">
                    <v-select v-model="parameters.isReturned" :searchable="false" dir="rtl" :options="isReturnedData"
                        class="bg-white" id="isReturnedId" autocomplete="off" :reduce="(value) => value.id"
                        style="border-radius: 6px;" label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="نوع سفارش" label-for="typeId">
                    <v-select v-model="parameters.type" :searchable="false" dir="rtl" :options="typeData" id="typeId"
                        class="bg-white" autocomplete="off" :reduce="(value) => value.id" style="border-radius: 6px;"
                        label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-25">
                <b-form-group label="نوع پرداخت" label-for="paymentMethodId">
                    <v-select v-model="parameters.paymentMethod" :searchable="false" dir="rtl" class="bg-white"
                        :options="paymentMethodData" autocomplete="off" id="paymentMethodId"
                        :reduce="(value) => value.id" style="border-radius: 6px;" label="name" :clearable="false">
                        <template #no-options>
                            موردی وجود ندارد
                        </template>
                    </v-select>
                </b-form-group>
            </b-col>
            <b-col md="3" lg="2" class="mt-md-2 mt-50">
                <b-button @click="removeFilters" variant="secondary" :disabled="loading"
                    class="d-flex justify-content-center w-100 mt-md-25 mt-0">
                    <span>حذف فیلتر ها</span>
                    <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                </b-button>
            </b-col>
            <b-col md="3" lg="2" class="mt-md-2 mt-1">
                <b-button variant="info" @click="ordersReport" :disabled="loading"
                    class="mt-md-25 mt-0 d-flex justify-content-center w-100">
                    <span>اعمال فیلتر</span>
                    <b-spinner v-if="loading" variant="white" class="ml-50" small></b-spinner>
                </b-button>
            </b-col>
        </b-row>
        <b-row class="mt-1">
            <b-col v-for="transaction in transactionData" :key="transaction.mode" md="6" lg="4">
                <b-card class="card-transaction" no-body>
                    <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                        <b-card-body>
                            <div class="transaction-item">
                                <div>
                                    <div>
                                        <h5 class="mb-50" :class="transaction.color">
                                            {{ transaction.mode }}
                                        </h5>
                                    </div>
                                    <div class="d-flex align-items-center" :class="transaction.color">
                                        <h4 class="mb-0" :class="transaction.color">
                                            {{ transaction.payment.toLocaleString('fa-IR') }}
                                        </h4>
                                        <h6 class="mb-0 ml-25" :class="transaction.color">{{ transaction.types }}</h6>
                                    </div>
                                </div>
                                <b-media no-body>
                                    <b-media-aside class="mr-0">
                                        <b-avatar rounded size="42" :variant="transaction.avatarVariant">
                                            <feather-icon size="20" :icon="transaction.avatar" />
                                        </b-avatar>
                                    </b-media-aside>
                                </b-media>
                            </div>
                        </b-card-body>
                    </b-overlay>
                </b-card>
            </b-col>
        </b-row>
        <b-card class="p-0" no-body>
            <b-overlay :show="loading" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table v-if="history.length" responsive :items="history" :fields="fields" class="mb-0" striped>
                    <template #cell(isReturned)="data">
                        <div :class="{ 'text-warning': data.item.isReturned }">
                            {{ data.item.isReturned ? 'مرجوع شده' : '-' }}
                        </div>
                    </template>
                    <template #cell(createdAt)="data">
                        <div>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                    2).join(":") }}
                            </span>
                        </div>
                    </template>
                    <template #cell(payableAmount)="data">
                        {{ data.item.payableAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(usedWalletAmount)="data">
                        {{ data.item.usedWalletAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(cashbackAmount)="data">
                        {{ data.item.cashbackAmount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(paymentMethod)="data">
                        {{ paymentMethod_Status(data.item.paymentMethod) }}
                    </template>
                    <template #cell(type)="data">
                        {{ type_Status(data.item.type) }}
                    </template>
                    <template #cell(registeredBy)="data">
                        {{ data.item.registeredBy ? data.item.registeredBy.firstName + " " +
                            data.item.registeredBy.lastName : 'مشتری' }}
                    </template>
                    <template #cell(ordersList)="data">
                        <b-spinner v-if="loadingButton[data.index]" variant="info" small></b-spinner>
                        <feather-icon v-else @click="showOrderList(data.item.id, data.index)" icon="ShoppingBagIcon"
                            class="text-info pointer" size="20" />
                    </template>
                </b-table>
                <div v-else class="text-center pt-5 pb-4">
                    موردی وجود ندارد
                </div>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="ordersReport" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />

        <!------------------------------- modal show order list ------------------------------->
        <b-modal id="show-order-list" title="جزئیات سفارش" centered :hide-footer="true" title-class="font-weight-bolder"
            size="lg">
            <div>
                <invoiceDetail :orderDetails="orderDetails" />
            </div>
        </b-modal>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BPagination, BOverlay, BAvatar, BMediaAside, BMedia, BMediaBody, BFormInput, BFormGroup, BSpinner } from 'bootstrap-vue';
import { storeService } from '@core/services';
import vSelect from 'vue-select';
import invoiceDetail from '@/@core/components/invoice-detail/index.vue';
import { accessHandling } from '@core/mixins/accessHandling';

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BPagination,
        BOverlay,
        BAvatar,
        BMediaAside,
        BMedia,
        BSpinner,
        BMediaBody,
        BFormInput,
        BFormGroup,
        vSelect,
        invoiceDetail
    },
    mixins: [accessHandling],
    data() {
        return {
            loadingPage: true,
            loading: false,
            history: [],
            paymentMethodData: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'نقدی' },
                { id: 1, name: 'کارت' },
                { id: 2, name: 'درگاه' },
                { id: 3, name: 'واریز به حساب' },
            ],
            typeData: [
                { id: null, name: 'نمایش همه' },
                { id: 0, name: 'داخل سالن' },
                { id: 1, name: 'بیرون بر' },
            ],
            hasTaxData: [
                { id: null, name: 'نمایش همه' },
                { id: true, name: 'محاسبه شده' },
                { id: false, name: 'محاسبه نشده' },
            ],
            isReturnedData: [
                { id: null, name: 'نمایش همه' },
                { id: true, name: 'مرجوع شده' },
                { id: false, name: 'مرجوع نشده' },
            ],
            transactionData: [
                {
                    mode: 'فروش',
                    types: 'ریال',
                    avatar: 'ArrowUpCircleIcon',
                    avatarVariant: 'light-primary',
                    payment: null,
                    color: 'text-primary',
                },
                {
                    mode: 'مرجوعی',
                    types: 'ریال',
                    avatar: 'ArrowDownCircleIcon',
                    avatarVariant: 'light-danger',
                    payment: null,
                    color: 'text-danger',
                },
                {
                    mode: 'خالص',
                    types: 'ریال',
                    avatar: 'DollarSignIcon',
                    avatarVariant: 'light-success',
                    payment: null,
                    color: 'text-success',
                },
                {
                    mode: 'تخفیف',
                    types: 'ریال',
                    avatar: 'PercentIcon',
                    avatarVariant: 'light-secondary',
                    payment: null,
                    color: '',
                },
                {
                    mode: 'هزینه ارسال',
                    types: 'ریال',
                    avatar: 'TruckIcon',
                    avatarVariant: 'light-secondary',
                    payment: null,
                    color: '',
                },
                {
                    mode: 'مالیات',
                    types: 'ریال',
                    avatar: 'CircleIcon',
                    avatarVariant: 'light-secondary',
                    payment: null,
                    color: '',
                },
                {
                    mode: 'اعتبار استفاده شده',
                    types: 'ریال',
                    avatar: 'CreditCardIcon',
                    avatarVariant: 'light-secondary',
                    payment: null,
                    color: '',
                },
                {
                    mode: 'اعتبار صادر شده',
                    types: 'ریال',
                    avatar: 'GiftIcon',
                    avatarVariant: 'light-secondary',
                    payment: null,
                    color: '',
                },
                {
                    mode: 'تعداد فاکتور ها',
                    types: 'عدد',
                    avatar: 'ShoppingBagIcon',
                    avatarVariant: 'light-secondary',
                    payment: null,
                    color: '',
                },
            ],
            fields: [
                {
                    key: 'storeOrderNumber',
                    label: 'شماره فاکتور',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'usedWalletAmount',
                    label: 'اعتبار استفاده شده (ریال)',
                },
                {
                    key: 'payableAmount',
                    label: 'مبلغ پرداخت شده (ریال)',
                },
                {
                    key: 'cashbackAmount',
                    label: 'اعتبار صادر شده (ریال)',
                },
                {
                    key: 'type',
                    label: 'نوع سفارش',
                },
                {
                    key: 'paymentMethod',
                    label: 'نوع پرداخت',
                },
                {
                    key: 'isReturned',
                    label: 'وضعیت مرجوعی',
                },
                {
                    key: 'registeredBy',
                    label: 'ثبت کننده',
                },
                {
                    key: 'ordersList',
                    label: 'جزئیات',
                },
            ],
            currentDate: '',
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                from: null,
                to: null,
                customerPhoneNumber: null,
                transactionCode: null,
                orderId: null,
                storeOrderNumber: null,
                userId: null,
                paymentMethod: null,
                isReturned: null,
                hasTax: null,
                type: null,
            },
            orderId: null,
            usersList: [],
            parametersUsers: {
                pageIndex: 1,
                pageSize: 90,
            },
            orderDetails: {},
            loadingButton: []
        }
    },
    computed: {
        type_Status() {
            return (status) => {
                if (status == 0) {
                    return 'داخل سالن'
                }
                if (status == 1) {
                    return 'بیرون بر'
                }
            }
        },
        paymentMethod_Status() {
            return (status) => {
                if (status == 0) {
                    return 'نقدی'
                }
                if (status == 1) {
                    return 'کارت'
                }
                if (status == 2) {
                    return 'درگاه'
                }
                if (status == 3) {
                    return 'واریز به حساب'
                }
                if (status == 255) {
                    return 'ترکیبی'
                }
            }
        },
    },
    methods: {
        formatDate2(date) {
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        },
        showOrderList(id, index) {
            if (this.accessHandling('employee', 'order_details_view')) {
                this.$set(this.loadingButton, index, true);
                storeService.orderDetails(this.storeId, id).then(({ data }) => {
                    this.orderDetails = data
                    this.$set(this.loadingButton, index, false);
                    this.$bvModal.show('show-order-list')
                })

                    .catch((err) => {
                        this.$set(this.loadingButton, index, false);
                    });
            }
            else {
                this.$notif({ type: 'error', title: 'شما به این بخش دسترسی ندارید' });
            }
        },
        formatDate(dateString) {
            const [year, month, day] = dateString.split('-');
            return new Date(year, parseInt(month) - 1, day).toLocaleDateString('fa-IR');
        },
        removeFilters() {
            let currentDate = new Date(Date.now());
            this.parameters.from = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`
            this.parameters.to = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate() + 1}`
            this.parameters.customerPhoneNumber = null
            this.parameters.transactionCode = null
            this.parameters.orderId = null
            this.parameters.storeOrderNumber = null
            this.parameters.userId = null
            this.parameters.paymentMethod = null
            this.parameters.isReturned = null
            this.parameters.hasTax = null
            this.parameters.type = null
            this.ordersReport()
        },
        getUsers() {
            storeService.getUsers(this.storeId, this.parametersUsers).then(({ data }) => {
                this.usersList = data.items
                this.usersList.unshift({
                    id: null,
                    lastName: '',
                    firstName: 'نمایش همه'
                })
                this.ordersReport()
            })
        },
        ordersReport() {
            this.loading = true
            storeService.ordersReport(this.storeId, this.parameters).then(({ data }) => {
                if (this.loadingPage) {
                    this.parameters.totalCount = data.totalCount
                    this.history = data.items
                    this.transactionData[0].payment = data.totalSell + data.totalReturned
                    this.transactionData[1].payment = data.totalReturned
                    this.transactionData[2].payment = data.totalSell
                    this.transactionData[3].payment = data.totalDiscounts
                    this.transactionData[4].payment = data.totalCourierFee
                    this.transactionData[5].payment = data.totalTaxes
                    this.transactionData[6].payment = data.totalUsedWallets
                    this.transactionData[7].payment = data.totalCashbacks
                    this.transactionData[8].payment = data.totalCount
                    if (this.history.length) {
                        this.history.forEach(obj => {
                            this.loadingButton.push(false)
                        });
                    }
                    this.loading = false
                }
                else {
                    setTimeout(() => {
                        this.parameters.totalCount = data.totalCount
                        this.history = data.items
                        this.transactionData[0].payment = data.totalSell + data.totalReturned
                        this.transactionData[1].payment = data.totalReturned
                        this.transactionData[2].payment = data.totalSell
                        this.transactionData[3].payment = data.totalDiscounts
                        this.transactionData[4].payment = data.totalCourierFee
                        this.transactionData[5].payment = data.totalTaxes
                        this.transactionData[6].payment = data.totalUsedWallets
                        this.transactionData[7].payment = data.totalCashbacks
                        this.transactionData[8].payment = data.totalCount
                        if (this.history.length) {
                            this.history.forEach(obj => {
                                this.loadingButton.push(false)
                            });
                        }
                        this.loading = false
                    }, 369)
                }
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);
        this.parameters.from = this.formatDate2(today);
        this.parameters.to = this.formatDate2(tomorrow);
        this.currentDate = this.parameters.to;
        this.getUsers()
    },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>